import { Component, OnInit } from '@angular/core';
import DatatableExtension from '@app/datatables/decorators/datatable-extension.decorator';
import { DatatableComponent } from '@app/datatables/models/custom-datatable-extension';
import { logValues } from '@app/utils/rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Api } from 'datatables.net';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

declare module 'datatables.net' {
  interface Feature {
    filter?: boolean;
  }
}

@UntilDestroy()
@Component({
  selector: 'portal-datatable-filter',
  templateUrl: './datatable-filter.component.html',
  styles: [],
  standalone: false,
})
@DatatableExtension({
  key: 'F',
  componentElement: '<portal-datatable-filter></portal-datatable-filter>',
  name: 'filter',
})
export class DatatableFilterComponent extends DatatableComponent implements OnInit {
  /**
   * The current value of the filter (we use a subject so we can easily debounce the input"
   */
  filter$: Subject<string> = new Subject();

  ngOnInit(): void {
    this.filter$.pipe(untilDestroyed(this), debounceTime(250), logValues()).subscribe((value) => {
      this.datatablePage.dtInstance.search(value).draw();
    });
  }

  onSearchInput(eventTarget: EventTarget) {
    const target = eventTarget as HTMLInputElement;

    this.search(target.value);
  }

  /**
   * Set the filter value and execute the datatable search
   * @param value
   */
  search(value: string) {
    this.filter$.next(value);
  }
}
